export const formSpecialization = [
  {
    id: 25,
    name: "Arts and Design",
    fields: [
      { id: 1, name: "Psychology" },
      { id: 2, name: "Law" },
      { id: 3, name: "Fine Arts" },
      { id: 4, name: "Teaching & Education" },
      { id: 5, name: "Fashion" },
      { id: 6, name: "Architecture" },
      { id: 7, name: "Interior Design" },
      { id: 8, name: "Music" },
      { id: 9, name: "Theatre & Performing Arts" },
      { id: 10, name: "Graphic Design / Multimedia" },
      { id: 11, name: "Social Work" },
      { id: 12, name: "Social Science" },
      { id: 13, name: "Economics" },
      { id: 14, name: "Arts Pathway" },
    ],
  },
  {
    id: 31,
    name: "Business Management",
    fields: [
      { id: 15, name: "Management" },
      { id: 16, name: "Sales & Marketing" },
      { id: 17, name: "Finance & Accounting" },
      { id: 18, name: "Human Resource" },
      { id: 19, name: "Project Management" },
      { id: 20, name: "International Business & Administration" },
      { id: 21, name: "Supply Chain Management" },
      { id: 22, name: "Entrepreneurship" },
      { id: 23, name: "Engineering Management" },
      { id: 24, name: "Leadership & Innovation" },
      { id: 25, name: "Airport & Aviation" },
      { id: 26, name: "Sports Management" },
      { id: 27, name: "Business Pathway" },
    ],
  },
  {
    id: 5,
    name: "Engineering",
    fields: [
      { id: 28, name: "Civil & Construction Engineering" },
      { id: 29, name: "Biomedical / Biotechnology Engineering" },
      { id: 30, name: "Electrical & Electronic Engineering" },
      { id: 31, name: "Automotive Engineering" },
      { id: 32, name: "Chemical Engineering" },
      { id: 33, name: "Mechanical Engineering" },
      { id: 34, name: "Engineering Management" },
      { id: 35, name: "Engineering Pathway" },
      { id: 36, name: "Aerospace Engineering" },
      { id: 37, name: "Environmental Engineering" },
      { id: 38, name: "Engineering (Dual Specializations)" },
    ],
  },
  {
    id: 26,
    name: "Media & Mass Communication",
    fields: [
      { id: 39, name: "Journalism" },
      { id: 40, name: "Advertising / Branding" },
      { id: 41, name: "Public Relations (PR)" },
      { id: 42, name: "Digital Media" },
      { id: 43, name: "Film & Television" },
      { id: 44, name: "Creative Writing" },
    ],
  },
  {
    id: 27,
    name: "Computer & IT",
    fields: [
      { id: 45, name: "Information Technology" },
      { id: 46, name: "Computer Science / Engineering" },
      { id: 47, name: "Data Science / Analytics" },
      { id: 48, name: "Cyber Security & Cloud Computing" },
      { id: 49, name: "Games Development" },
      { id: 50, name: "Artificial Intelligence & Robotics" },
      { id: 51, name: "Business Information System" },
      { id: 52, name: "Computational Mathematics" },
    ],
  },
  {
    id: 28,
    name: "Science",
    fields: [
      { id: 53, name: "Geology" },
      { id: 54, name: "Actuarial Science" },
      { id: 55, name: "Chemistry & Physics" },
      { id: 56, name: "Biology & Biomedical Sciences" },
      { id: 57, name: "Health / Medical Science" },
      { id: 58, name: "Sports Science" },
      { id: 59, name: "Psychology" },
      { id: 60, name: "Veterinary Sciences" },
      { id: 61, name: "Environmental Science" },
      { id: 62, name: "Forensic Science" },
      { id: 63, name: "Mathematics & Statistics" },
      { id: 64, name: "Food & Nutrition" },
      { id: 65, name: "General Science" },
    ],
  },
  {
    id: 29,
    name: "Hospitality",
    fields: [
      { id: 66, name: "Hospitality & Tourism" },
      { id: 67, name: "Food & Beverage / Restaurant" },
      { id: 68, name: "Culinary" },
      { id: 69, name: "Travel & Tourism" },
      { id: 70, name: "Event & Leisure" },
      { id: 71, name: "Hospitality & Design" },
      { id: 72, name: "International Hospitality & Business" },
      { id: 73, name: "Hospitality & Entrepreneurship" },
      { id: 74, name: "Hospitality, Resort & Spa" },
      { id: 75, name: "Bakery & Pastry / Chocolate" },
      { id: 76, name: "Gastronomy" },
      { id: 77, name: "Wine & Beverage" },
    ],
  },
  {
    id: 30,
    name: "Medicine",
    fields: [
      { id: 78, name: "Dentistry" },
      { id: 79, name: "Nursing" },
    ],
  },
  {
    id: 32,
    name: "MBBS",
    fields: [{ id: 80, name: "MBBS" }],
  },
];

export const countries = [
  { country_id: 14, country_name: "USA", states: [] },
  { country_id: 4, country_name: "United Kingdom", states: [] },
  { country_id: 7, country_name: "Canada", states: [] },
  { country_id: 18, country_name: "Ireland", states: [] },
  { country_id: 6, country_name: "Australia", states: [] },
  { country_id: 8, country_name: "Switzerland", states: [] },
  // { country_id: 37, country_name: "Barbados", states: [] },
  { country_id: 10, country_name: "France", states: [] },
  { country_id: 2, country_name: "UAE", states: [] },
  { country_id: 9, country_name: "Germany", states: [] },
  { country_id: 11, country_name: "Hungary", states: [] },
  { country_id: 5, country_name: "New Zealand", states: [] },
  // { country_id: 1, country_name: "India", states: [] },
  { country_id: 17, country_name: "Italy", states: [] },
  // { country_id: 38, country_name: "Kuwait", states: [] },
  { country_id: 21, country_name: "Latvia", states: [] },
  { country_id: 16, country_name: "Malaysia", states: [] },
  // { country_id: 36, country_name: "Netherlands", states: [] },
  // { country_id: 22, country_name: "North Cyprus", states: [] },
  // { country_id: 20, country_name: "Poland", states: [] },
  { country_id: 13, country_name: "Russia", states: [] },
  { country_id: 12, country_name: "Singapore", states: [] },
  { country_id: 15, country_name: "Georgia", states: [] },
  { country_id: 19, country_name: "Spain", states: [] },
];

export const courseLevels = [
  {
    course_level_id: 3,
    course_level_name: "Diploma",
    course_level_description: "Diploma",
  },
  {
    course_level_id: 7,
    course_level_name: "Bachelor",
    course_level_description: null,
  },
  {
    course_level_id: 5,
    course_level_name: "Master/PG",
    course_level_description: "",
  },
  {
    course_level_id: 6,
    course_level_name: "MBA",
    course_level_description: "",
  },
];



// WEBPACK FOOTER //
// ./src/data/json/form-specialization.js